import { render, staticRenderFns } from "./ContactDetailCard.vue?vue&type=template&id=2f2dfa35&scoped=true"
import script from "./ContactDetailCard.vue?vue&type=script&lang=ts"
export * from "./ContactDetailCard.vue?vue&type=script&lang=ts"
import style0 from "./ContactDetailCard.vue?vue&type=style&index=0&id=2f2dfa35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2dfa35",
  null
  
)

export default component.exports